// Pages Enums
export const HOME = '1';
export const MAIN_SALE_SCREEN = '2';
export const SALES_LEDGER = '3';
export const REPORTS_DASHBOARD = '4';
export const PRODUCT_SCREEN ='5';
export const CUSTOMER = '6';
export const GENERAL_SCREEN = '7';
export const OPEN_CLOSE = '8';
export const SALE_HISTORY = '9';
export const CASH_LISTING = '12';
export const STATUS = '13';
export const SELL_SETTING = '14';
export const SALES_REPORT = '15';
export const INVENTORY_REPORT = '16';
export const PAYMENT_REPORT = '17';
export const REPORT_CLOSURE = '18';
export const GIFT_CARD_REPORT = '19';
export const REPORT_STORE_CREDIT = '20';
export const TAX_REPORT = '21';
export const STOCK_LIST = '22';
export const INVENTORY_SCREEN = '23';
export const PROMOTION = '24';
export const PRICEBOOK = '25';
export const PRODUCTTYPE = '26';
export const SUPPLIER = '27';
export const BRANDS = '28';
export const PRODUCTTAGS = '29';
export const CUSTOMER_GROUP = '30';
export const BILLING_PLAN = '31';
export const OUTLETREGISTER_SCREEN = '32';
export const PAYMENT_SCREEN = '33';
export const TAX_SCREEN = '34';
export const LOYALTY_SCREEN = '35';
export const USERROLES_SCREEN = '36';
export const ADD_ONS = '37';
export const PERSONAL_TOKENS = '38';
export const GIFT_CARDS = '39';
export const STORE_CREDIT = '40';
export const SALE_TRACKING_SCREEN = '44';
export const PRINTING = '45';
export const OTHERREPORTS = '46'
export const SALES_DISCOUNT_SCREEN = '47';